import DocumentTable from './components/Document.vue';
import EducationTable from './components/Education.vue';
import WorkHistoryTable from './components/WorkHistory.vue';
import PersonalRefsTable from './components/PersonalRefs.vue';
import FamilyDetailsTable from './components/FamilyDetails.vue'

frappe.provide("main");
Object.assign(main, {
	override_document_table: function (form, doc, is_new, allow_edit, set_value) {
		main.document_table = new Vue({
			el: "div[data-fieldname=document_table]",
			render(h) {
				return h(DocumentTable, {
					props: {
						form: form,
						doc: doc,
						is_new: is_new(),
						allow_edit: allow_edit(),
						set_value: set_value
					}
				});
			}
		});
	},
	override_education_table: function (form, doc, is_new, allow_edit, set_value) {
		main.education_table = new Vue({
			el: "div[data-fieldname=education]",
			render(h) {
				return h(EducationTable, {
					props: {
						form: form,
						doc: doc,
						is_new: is_new(),
						allow_edit: allow_edit(),
						set_value: set_value
					}
				});
			}
		});
	},
	override_work_history_table: function (form, doc, is_new, allow_edit, set_value) {
		main.work_history_table = new Vue({
			el: "div[data-fieldname=external_work_history]",
			render(h) {
				return h(WorkHistoryTable, {
					props: {
						form: form,
						doc: doc,
						is_new: is_new(),
						allow_edit: allow_edit(),
						set_value: set_value
					}
				});
			}
		});
	},
	override_professional_references_table: function (form, doc, is_new, allow_edit, set_value) {
		main.professional_references_table = new Vue({
			el: "div[data-fieldname=professional_references]",
			render(h) {
				return h(PersonalRefsTable, {
					props: {
						form: form,
						doc: doc,
						is_new: is_new(),
						allow_edit: allow_edit(),
						set_value: set_value
					}
				});
			}
		});
	},
	override_family_details_table: function (form, doc, is_new, allow_edit, set_value) {
		main.override_family_details_table = new Vue({
			el: "div[data-fieldname=family_details]",
			render(h) {
				return h(FamilyDetailsTable, {
					props: {
						form: form,
						doc: doc,
						is_new: is_new(),
						allow_edit: allow_edit(),
						set_value: set_value
					}
				});
			}
		});
	},
});